<template>
  <modal
    v-if="show && video"
    @leave="close()"
    :scrollY="false"
    :showCloseBtn="true"
  >
    <iframe
      :src="video.vimeo_url"
      class="w-full h-5/6"
      frameborder="0"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen
    ></iframe>

    <table
      v-if="video.vimeo_url"
      class="w-full mt-4 text-sm mb-8"
    >
      <tr class="bg-grey-lighter">
        <td class="p-3 w-1/5 text-right">Vimeo</td>
        <td class="p-3 w-4/5 text-left">
          <a :href="video.vimeo_url">{{ video.vimeo_url }}</a>
        </td>
      </tr>
    </table>
  </modal>
</template>

<script>
export default {
  name: 'ViewVideoModal',

  props: ['show', 'video'],

  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
